<template>
  <div>
    <ContTitle title="PORTFOLIO" />
    <PortCont />
  </div>
</template>
<script>
import ContTitle from "@/components/layout/ContTitle.vue";
import PortCont from "@/components/port/PortCont.vue";

export default {
  components: {
    ContTitle,
    PortCont,
  },
};
</script>
